import React from 'react';
import { Card } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';
import ImageBlock from "../ImageBlock/imageBlock.component";
// import styled from "styled-components";

import './examCard.module.css';

const ExamCard = ({ banner, title, subTitle, price, discount, link }, ...props) => {
    return (
        <Card styleName="exam-card">
            <ImageBlock
                width={530}
                height={280}
                src={banner}
            />
            <Card.Body>
                <Card.Title className="text-truncate" styleName="exam-card-title">
                    <LinkContainer to={link}>
                        <Card.Link title={!!title && title}>{!!title && title}</Card.Link>
                    </LinkContainer>
                </Card.Title>
                <Card.Text styleName="exam-card-subtitle">
                    {!!subTitle && subTitle}
                </Card.Text>
            </Card.Body>
            <Card.Body>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <Card.Link styleName="enroll-btn" className="custom-btn-dark pulse" href="#">Enroll</Card.Link>
                    <div className="d-inline" styleName="exam-card-statistics">


                        {(!!discount &&
                            <div className="d-flex flex-wrap align-items-end">
                                <span className="px-1">মূল্যঃ</span>
                                <div className="d-flex flex-column">
                                    <span className="px-1">
                                        <span className="pr-1" styleName="has-discount">
                                            {price}
                                        </span>
                                        {price - discount} টাকা
                                    </span>
                                </div>
                            </div>
                        ) ||
                            (
                                (price === 0) ?
                                    <span className="px-1">
                                        Free
                                    </span> :
                                    <span className="px-1">
                                        মূল্যঃ {price - discount} টাকা
                                    </span>
                            )}
                    </div>
                </div>
                {/* <Card.Link href="#">Another Link</Card.Link> */}
            </Card.Body>
        </Card>
    )
}

export default ExamCard;